import React from 'react';
import PropTypes from 'prop-types';
import styles from './ConferenceTypeToggle.module.css';

const ConferenceTypeToggle = ({ value, onChange }) => {
  const options = [
    { value: 'all', label: 'All' },
    { value: 'conf', label: 'Conf' },
    { value: 'non-conf', label: 'Non-Conf' }
  ];

  return (
    <div className={styles.toggleContainer}>
      <div className={styles.label}>Conference Type:</div>
      <div className={styles.segmentedControl} role="radiogroup" aria-label="Conference Type">
        {options.map((option) => (
          <label key={option.value} className={`${styles.segment} ${value === option.value ? styles.active : ''}`}>
            <input
              type="radio"
              name="conferenceType"
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange(option.value)}
              className={styles.hiddenInput}
            />
            <span>{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

ConferenceTypeToggle.propTypes = {
  value: PropTypes.oneOf(['all', 'conf', 'non-conf']).isRequired,
  onChange: PropTypes.func.isRequired
};

export default ConferenceTypeToggle;
